import { render } from "./B2bTableMenuServicios.vue?vue&type=template&id=66baa818&scoped=true&lang=pug"
import script from "./B2bTableMenuServicios.vue?vue&type=script&lang=js"
export * from "./B2bTableMenuServicios.vue?vue&type=script&lang=js"

import "./B2bTableMenuServicios.vue?vue&type=style&index=0&id=66baa818&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-66baa818"]])

export default __exports__